"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changePasswordMutationOptions = exports.changePasswordMutation = void 0;
const client_1 = require("@apollo/client");
const meUser_1 = require("../fragments/meUser");
const me_1 = require("../queries/me");
exports.changePasswordMutation = client_1.gql `
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      __typename
      errors {
        path
        message
      }
      user {
        ...meUser
      }
    }
  }

  ${meUser_1.meUserFragment}
`;
exports.changePasswordMutationOptions = (variables) => ({
    variables,
    update: (cache, { data }) => {
        if (!data || !data.changePassword.user) {
            return;
        }
        cache.writeQuery({
            query: me_1.meQuery,
            data: {
                __typename: "Query",
                me: {
                    __typename: "UserResponse",
                    user: Object.assign({}, data.changePassword.user),
                },
            },
        });
    },
});
//# sourceMappingURL=changePassword.js.map